import React, { memo } from 'react'
import styles from './RecommendationProductOptions.module.scss'
import Slider, { Settings } from 'react-slick'
import { useNavigate } from 'react-router-dom'
import { ApplicationRoutes } from '../../../../routes'
import { useDispatch, useSelector } from 'react-redux'
import { RecommendationOptions, bestOfferImage, budgetOfferImage, countOfBudgetOffers, countOfPowerNeedsOffers, option, powerNeedsOfferImage } from '../../../../stores/slices/solar-recommendation-slice'
import NotFoundRecommendationItems from './NotFoundRecommendationItems'
import { AppDispatch } from '../../../../stores/store'

type Props = {}

const RecommendationProductOptions: React.FC<Props> = memo((props: Props) => {
    const settings: Settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,        
    };

    const dispatch = useDispatch<AppDispatch>();

    const bestOfferImageDisplay = useSelector(bestOfferImage);
    const budgetFitImageDisplay = useSelector(budgetOfferImage);
    const energyNeedImageDisplay = useSelector(powerNeedsOfferImage);
    const countOfBudgetFit = useSelector(countOfBudgetOffers);
    const countOfEnergyNeed = useSelector(countOfPowerNeedsOffers);

    const navigate = useNavigate();

    const goToProducts = (selectedOption : RecommendationOptions) => {
        dispatch(option(selectedOption))
        navigate(`/${ApplicationRoutes.RECOMMENDATION_PRODUCTS}`);
    }

    return (
        <div className={styles.container}>
            <div className={styles.sliderContainer}>
                <Slider {...settings}>
                    <div className={`${styles.optionContainer}`}>
                        <div className={styles.optionTextContainer}>
                            <div className={styles.optionTitle}>
                                Best offer
                            </div>
                            <button className={`standardButton ${styles.seeDetailsButton}`} onClick={() => goToProducts(RecommendationOptions.BEST_OFFER)}>
                                See details <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.1665 10H15.8332" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.8335 15L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.8335 5L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                        {
                            bestOfferImageDisplay ? 
                            <img src="/images/best-fit-products.png" alt="Best Offer" /> :
                            <NotFoundRecommendationItems />
                        }
                    </div>
                    <div className={`${styles.optionContainer}`}>
                        <div className={styles.optionTextContainer}>
                            <div className={styles.optionTitle}>
                                Budget fit
                            </div>
                            <div className={styles.optionSubtitle}>
                                {countOfBudgetFit} Products available
                            </div>
                            <button className={`standardButton ${styles.seeDetailsButton}`} onClick={() => goToProducts(RecommendationOptions.BUDGET_FIT)}>
                                See details <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.1665 10H15.8332" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.8335 15L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.8335 5L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                        {
                            budgetFitImageDisplay ? 
                            <img src="/images/budget-fit-products.jpg" alt="Best Offer" /> : 
                            <NotFoundRecommendationItems />
                        }
                    </div>
                    <div className={`${styles.optionContainer}`}>
                        <div className={styles.optionTextContainer}>
                            <div className={styles.optionTitle}>
                                Energy need
                            </div>
                            <div className={styles.optionSubtitle}>
                                {countOfEnergyNeed} Products available
                            </div>
                            <button className={`standardButton ${styles.seeDetailsButton}`} onClick={() => goToProducts(RecommendationOptions.ENERGY_NEED)}>
                                See details <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.1665 10H15.8332" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.8335 15L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.8335 5L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                        {
                            energyNeedImageDisplay ? 
                            <img src="/images/energy-fit-products.jpg" alt="Best Offer" /> : 
                            <NotFoundRecommendationItems />
                        }
                    </div>
                </Slider>
            </div>
            <div className={styles.gridLayout}>
                <div className={`${styles.optionContainer} ${styles.bestOfferOption}`}>
                    <div className={styles.optionTextContainer}>
                        <div className={styles.optionTitle}>
                            Best offer
                        </div>
                        <button className={`standardButton ${styles.seeDetailsButton}`} onClick={() => goToProducts(RecommendationOptions.BEST_OFFER)}>
                            See details <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.1665 10H15.8332" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.8335 15L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.8335 5L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                    {
                        bestOfferImageDisplay ?
                        <img src="/images/best-fit-products.png" alt="Best Offer" /> :
                        <NotFoundRecommendationItems />
                    }
                </div>
                <div className={`${styles.optionContainer}`}>
                    <div className={styles.optionTextContainer}>
                        <div className={styles.optionTitle}>
                            Budget fit
                        </div>
                        <div className={styles.optionSubtitle}>
                            {countOfBudgetFit} Products available
                        </div>
                        <button className={`standardButton ${styles.seeDetailsButton}`} onClick={() => goToProducts(RecommendationOptions.BUDGET_FIT)}>
                            See details <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.1665 10H15.8332" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.8335 15L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.8335 5L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                    {
                        budgetFitImageDisplay ? 
                        <img src="/images/budget-fit-products.jpg" alt="Best Offer" /> : <NotFoundRecommendationItems />
                    }
                </div>
                <div className={`${styles.optionContainer}`} >
                    <div className={styles.optionTextContainer}>
                        <div className={styles.optionTitle}>
                            Energy need
                        </div>
                        <div className={styles.optionSubtitle}>
                            {countOfEnergyNeed} Products available
                        </div>
                        <button className={`standardButton ${styles.seeDetailsButton}`} onClick={() => goToProducts(RecommendationOptions.ENERGY_NEED)}>
                            See details <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.1665 10H15.8332" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.8335 15L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.8335 5L15.8335 10" stroke="var(--app-primary-text)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                    {
                        energyNeedImageDisplay ?
                            <img src="/images/energy-fit-products.jpg" alt="Best Offer" /> :
                            <NotFoundRecommendationItems />
                    }
                </div>
            </div>
        </div>
    )
})

export default RecommendationProductOptions